module.exports = __webpack_public_path__ + "img/telegram.24c32baf.svg";